import React from "react";
import InlineSVG from "react-inlinesvg";

const SvgIcon = ({ src, className = "" }) => {
  return (
    <InlineSVG
      src={src}
      preProcessor={(code) => code.replace(/fill="[^"]*"/g, 'fill="currentColor"')}
      className={className}
    />
  );
};

export default SvgIcon;
